export default "__VITE_ASSET__8Av_8NfKYbmM0$Et3J6Emw__"